<script>
import Carregando from '~componentes/Carregando.vue';
import assinaturaEmbedServico from '../servico';

export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      erro: '',
    }
  },
  mounted() {
    this.iniciarSessao();
  },
  methods: {
    iniciarSessao() {
      const token = this.$route.query.token;

      if (!token) {
        this.carregando = false;
        this.erro = 'Não foi possível abrir a assinatura eletrônica. Acesse novamente pelo sistema.';
        return;
      }

      this.$storage.limpar();

      return assinaturaEmbedServico
        .iniciarSessao(token)
        .then(dados => {
          this.$storage.usuario(dados.usuario);
          this.$storage.token(dados.token);

          const parametros = dados.parametros;

          if (parametros && parametros.acao === 'detalhes' && parametros.idDocumentoAssinaturaAssinante) {
            this.$router.replace({
              name: 'assinatura-embed.detalhes',
              params: { id: parametros.idDocumentoAssinaturaAssinante },
            });
            return;
          }

          this.$router.replace({ name: 'assinatura-embed' });
        })
        .catch(() => {
          this.carregando = false;
          this.erro = 'Sessão expirada ou inválida. Feche esta janela e abra novamente pelo sistema.';
        });
    },
  }
}
</script>

<template>
  <div>
    <carregando v-if="carregando"></carregando>

    <div v-if="erro" class="ibox float-e-margins">
      <div class="ibox-content text-center">
        <h2>Assinatura Eletrônica</h2>
        <div class="alert alert-warning no-margin-bottom">
          {{ erro }}
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/assinatura-embed/componentes/Sessao.vue